// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"648":"a25b6608","703":"f516307c"}[chunkId] + ".chunk.js";
};